import {
  FeatureFlag,
  useFeatureFlag,
} from "@adsk/acc-issues-core/utils/featureFlags";
import { setWatcherProp } from "@adsk/acc-issues-core/state/redux/ducks/watchers";
import { useEffect } from "react";
import { useDispatch } from "@adsk/acc-issues-core/state/redux/hooks";

export const useWatcherPropName = (): "watchers" | "watcherObjects" => {
  const { value: shouldUseWatcherObjectsProperty } = useFeatureFlag(
    FeatureFlag.UseWatcherObjectsProperty
  );
  const dispatch = useDispatch();

  const watcherProp = shouldUseWatcherObjectsProperty
    ? "watcherObjects"
    : "watchers";

  useEffect(() => {
    dispatch(setWatcherProp(watcherProp));
  }, [watcherProp, dispatch]);
  return watcherProp;
};
